import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { useHistory } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import ChallengesInProgressIcon from '../../assets/images/Challenges-in-progress.svg';
import challengesCheck from '../../assets/images/challenges-check.svg';
import IIcon from '../../assets/icon/PRINT.svg';
import ChooseChallengeImg from '../../assets/images/tour/choose_challenge.svg';
import { nextChallengeViewModel } from '../views/next_challenge/next.challenge.viewmodel';
import {
  CHALLENGE_ROUTE,
  MULTI_LOGIN,
  NEXT_CHALLENGE_ROUTE,
  SPECIAL_CHALLENGE_ROUTE,
} from '../../constants/routes.constants';
import './binkiesCompliments.css';
import RoundButton from '../common/RoundButton';
import { useAuth } from '../auth/Auth';
import OptimizeSignup from '../views/onboarding/signup_popups/OptimizeSignup';
import GuardianNoDataTooltip from '../views/school/camp_tour/GuardianNoDataTooltip';
import { useHandleMultiLogin } from '../../utils/multilogin';

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 8,
  padding: theme.spacing(2),
  boxShadow: 'none',
}));

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  borderRadius: 8,
  boxShadow: 'none',
  border: '2px solid #6BD58C',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  marginRight: theme.spacing(2),
  cursor: 'pointer',
}));

const Content = styled(CardContent)({
  flex: '1 0 auto',
  padding: '0px 14px',
});

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

const Icon = styled('img')({
  marginRight: '21px',
  paddingLeft: '10px',
});

const commentColors = [
  '#ffd29f',
  '#C0FECF',
  '#F2F6AB',
  '#D6D5FD',
  '#B3E5FE',
  '#9CF2F1',
  '#FDE988',
  '#ffd6fa',
  '#d6fbff',
  '#ddd6ff',
];

const ChallengesInProgress = ({ type, dependent, cardClass }) => {
  const _PAGE_LIMIT = 3;
  const [compliments, setCompliments] = useState([]);
  const [dependentCompletedChalleges, setDependentCompletedChalleges] =
    useState([]);
  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);
  const tooltipStepData = [
    {
      element: '#guardian-choose-challenge',
      intro: `
        <div class="custom-tour-step">
          <img src="${ChooseChallengeImg}" alt="Camp Master" class="tour-avatar" />
          <h3>See Challenges in Progress</h3>
          <p>Track your child’s active challenges and monitor their progress as they engage in creative activities.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];
  const tooltipStepDataSchool = [
    {
      element: '#guardian-choose-challenge',
      intro: `
        <div class="custom-tour-step">
          <img src="${ChooseChallengeImg}" alt="Camp Master" class="tour-avatar" />
          <h3>See Challenges in Progress</h3>
          <p>Track active challenges and monitor their progress as they engage in creative activities.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];
  const history = useHistory();
  const { school } = useAuth();

  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
    dependent_id: dependent.id,
  });

  const getComplimentsReceived = () => {
    const params = { dependent_id: dependent.id };
    nextChallengeViewModel
      .getMyRoomChallenges('working', params)
      .then((res) => {
        setCompliments(res.challengeList);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCompletedChalleges = () => {
    const params = { dependent_id: dependent.id };
    nextChallengeViewModel
      .getMyRoomChallenges('all', params)
      .then((res) => {
        // Get the latest three challenges from the response
        const latestChallenges = res.challengeList.slice(0, 3);
        setDependentCompletedChalleges(latestChallenges);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    setCompliments([]);
    setQuery((prev) => ({ ...prev, dependent_id: dependent.id }));
    getComplimentsReceived();
    getCompletedChalleges();
  }, [dependent]);

  const onChallengeClick = (challenge) => {
    let path = CHALLENGE_ROUTE;
    let encodeQuery = btoa(`{"id":${challenge.id}, "slug":"challenge"}`);
    if (challenge?.special_camp?.id) {
      path = SPECIAL_CHALLENGE_ROUTE;
      encodeQuery = btoa(`{"id":${challenge.id}, "slug":"special-challenge"}`);
    }
    history.push({
      pathname: path,
      search: `?encrypt=${encodeQuery}`,
    });
  };

  // const [showModal, setShowModal] = useState(false);
  const { handleChildLogin } = useHandleMultiLogin();

  const handleChooseChallengeClick = () => {
    handleChildLogin(dependent.id, NEXT_CHALLENGE_ROUTE);
    // setShowModal(true);NEXT_CHALLENGE_ROUTE
    // history.push(MULTI_LOGIN);
  };
  const identifyGender = (genderType) =>
    genderType === 'male' ? 'him' : 'her';
  return (
    <>
      {/* {showModal && (
        <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
      )} */}
      <GuardianNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={school ? tooltipStepDataSchool : tooltipStepData}
      />
      <Typography
        variant="h6"
        className="compliments-received challenges-progress-main progress-heading"
      >
        <Icon src={ChallengesInProgressIcon} />
        Challenges Accepted
      </Typography>
      {/* <Divider /> */}
      {compliments.length > 0 &&
        compliments.map((compliment, index) => (
          <React.Fragment key={index}>
            {/* <Divider /> */}
            <StyledCard>
              <StyledAvatar src={compliment?.picture_url} />
              <Content className="checkIcon-div">
                <Typography
                  className="insights-challenges challenges-progress check-process"
                  variant="body2"
                  color="textSecondary"
                >
                  {compliment.title}
                  <img src={challengesCheck} />
                </Typography>
              </Content>
            </StyledCard>
          </React.Fragment>
        ))}
      {!compliments.length && (
        <>
          <div
            className="insights-text no-data-found"
            id="guardian-choose-challenge"
          >
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={() => setShowNoDataTooltip(true)}
              />
              <Typography variant="body1">
                {school
                  ? `${dependent?.username} hasn't selected a challenge yet.`
                  : `${
                      dependent?.username
                    } hasn't selected a challenge yet. Why not
              give ${identifyGender(
                dependent.profile.gender
              )} a hand and help ${identifyGender(
                      dependent.profile.gender
                    )} choose an exciting one he'll truly
              enjoy?`}
              </Typography>
              {!school &&
              !compliments.length &&
              dependentCompletedChalleges.length ? (
                <RoundButton
                  type="button"
                  label="Choose Challenges"
                  className="transparent-button d-sm-block choose-challenge-btn parent-login-btn"
                  onClick={() => history.push(MULTI_LOGIN)}
                />
              ) : (
                ''
              )}
              {!school &&
              compliments.length &&
              !dependentCompletedChalleges.length ? (
                <RoundButton
                  type="button"
                  label="Choose Challenges"
                  className="transparent-button d-sm-block choose-challenge-btn parent-login-btn"
                  onClick={() => history.push(MULTI_LOGIN)}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </>
      )}
      <Box>
        <Typography
          variant="h6"
          sx={{ mt: '16px', justifyContent: 'flex-start !important' }}
          className="compliments-received challenges-progress-main progress-heading"
        >
          <Icon src={ChallengesInProgressIcon} />
          Challenges Completed
        </Typography>
      </Box>
      {/* <Divider /> */}
      {dependentCompletedChalleges.length > 0 ? (
        dependentCompletedChalleges.map((completedChalleges, index) => (
          <React.Fragment key={index}>
            {/* <Divider /> */}
            <StyledCard>
              <StyledAvatar src={completedChalleges?.picture_url} />
              <Content className="checkIcon-div">
                <Typography
                  className="insights-challenges challenges-progress check-process"
                  variant="body2"
                  color="textSecondary"
                >
                  {completedChalleges.title}
                  <img src={challengesCheck} />
                </Typography>
              </Content>
            </StyledCard>
          </React.Fragment>
        ))
      ) : (
        <>
          <div
            className="insights-text no-data-found"
            id="guardian-choose-challenge"
          >
            <div className="text-wrapper" style={{ paddingBottom: '16px' }}>
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={() => setShowNoDataTooltip(true)}
              />
              <Typography variant="body1">
                {`${dependent?.username} hasn't completed any challenge yet.`}
              </Typography>
            </div>
          </div>
        </>
      )}
      <div
        className="insights-text no-data-found"
        id="guardian-choose-challenge"
      >
        {/* <div className="text-wrapper">
          {!school &&
          compliments.length &&
          !dependentCompletedChalleges.length ? (
            <RoundButton
              type="button"
              label="Choose Challenges"
              className="transparent-button d-sm-block choose-challenge-btn parent-login-btn"
              onClick={() => history.push(MULTI_LOGIN)}
            />
          ) : (
            ''
          )}
        </div> */}
      </div>
      <div
        className="insights-text no-data-found"
        id="guardian-choose-challenge"
      >
        <div className="text-wrapper">
          {!school &&
          !compliments.length &&
          !dependentCompletedChalleges.length ? (
            <RoundButton
              type="button"
              label="Choose Challenges"
              className="transparent-button d-sm-block choose-challenge-btn parent-login-btn"
              onClick={() => history.push(MULTI_LOGIN)}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default ChallengesInProgress;
